module.exports = __webpack_public_path__ + "img/inductrialInjuryPrevention_6.0251b05e.png";